import React from 'react'

import { Skeleton } from '@mui/material'

import { ISkeletonLoader, LoaderType } from '@interfaces/components/atoms/SkeletonLoader'

import './styles.scss'

const SkeletonLoader: React.FC<ISkeletonLoader> = ({ className, type, color }) => {
  if (type === LoaderType.Prompt) {
    return (
      <div className={className}>
        <Skeleton animation="wave" sx={{ bgcolor: color }} />
        <Skeleton animation="wave" width="80%" sx={{ bgcolor: color }} />
        <Skeleton animation="wave" width="60%" sx={{ bgcolor: color }} />
      </div>
    )
  }
  return (
    <div className={className}>
      <div className="SLTemplateImage">
        <Skeleton
          animation="wave"
          variant="rounded"
          width="100%"
          height="100%"
          sx={{ bgcolor: color }}
        />
      </div>
      <Skeleton animation="wave" className="mt-3" sx={{ bgcolor: color }} />
      <Skeleton animation="wave" width="60%" sx={{ bgcolor: color }} />
      <Skeleton animation="wave" width="40%" sx={{ bgcolor: color }} />
    </div>
  )
}

export default SkeletonLoader
